<template>
  <el-tag :type="type" :size="size" :effect="effect">{{statusName}}</el-tag>
</template>
<script>

import ProductUtil from '@/utils/product-util'

export default {
  name: 'Sales-order-status-tag',
  props: {
    status: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: null
    },
    effect: {
      type: String,
      default: 'plain'
    }
	},
  data() {
    return {

    };
  },components: {

  },
	methods: {

	},
	computed: {
    statusCode () {
      return _.get(this.status, 'code');
    },
    type(){
      // success, info,  danger, warning
      if (this.statusCode === 'TO_PROCESS' || this.statusCode === 'TO_PROCESS_PAID' ) {
        return 'warning'
      } else if (this.statusCode === 'VOIDED' || this.statusCode === 'REJECTED') {
        return 'danger';
      } else if (this.statusCode=== 'COMPLETED') {
        return 'success';
      } else {
        return 'info'
      }
    },
    statusName(){
      return this.$i18n.t(`sales_orders.statuses.${this.statusCode}`);
    },
	},
}
</script>

<style lang="scss" scoped>

</style>
